class BHouses extends HTMLElement {
  connectedCallback() {
    this.items = [...this.querySelectorAll('[data-house-index]')];
    this.figures = [...this.querySelectorAll('.b-houses__figure')];
    const activate = (e) => this.activate(Number(e.currentTarget.dataset.houseIndex));
    this.items.forEach((item) => { item.addEventListener('mouseenter', activate); item.addEventListener('focus', activate); });
  }

  activate(index) {
    this.items.forEach((el, i) => el.classList.toggle('is-active', i === index));
    this.figures.forEach((el, i) => {
      el.classList.toggle('is-active', i === index);
      el.setAttribute('aria-hidden', String(i !== index));
    });
  }
}
if (!customElements.get('b-houses')) customElements.define('b-houses', BHouses);
